import { createSelector } from "reselect";
import { getAllLessons, getLessonId } from "./lessonSelectors";
import orderByPosition from "../utils/orderByPosition";
import { getAllLevels } from "./levelSelectors";

const getLessonFiles = (state) => state.entities.lessonFiles;
const getId = (_, id) => id;

export const getAllLessonFiles = createSelector(getLessonFiles, (files) =>
  Object.values(files)
);

export const getFilesFromLesson = createSelector(
  getLessonId,
  getLessonFiles,
  (lessonId, files) =>
    Object.values(files).filter((file) => file.lessonId === lessonId)
);

export const makeHasFiles = createSelector(
  getLessonId,
  getLessonFiles,
  (lessonId, files) =>
    !!Object.values(files).filter((file) => file.lessonId === lessonId).length
);

export const getLessonFilesByCourseId = createSelector(
  getAllLessonFiles,
  getId,
  getAllLevels,
  getAllLessons,
  (files, courseId, levels, lessons) => {
    const orderedLessons = [];
    levels
      ?.filter((level) => level.courseId === courseId)
      .sort(orderByPosition)
      .map((level) => {
        lessons
          ?.filter((lesson) => lesson.levelId === level.id)
          .sort(orderByPosition)
          .map((lesson) => orderedLessons.push(lesson));
      });

    const orderedFiles = [];
    orderedLessons.map(({ id: lessonId }) => {
      files
        .filter((file) => file.lessonId === lessonId && file.courseId === courseId)
        .sort(orderByPosition)
        .map((file) => orderedFiles.push(file));
    })

    return orderedFiles;
  }
);
